import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import type { Skill } from '../types';
import { getCompositionAuthoringGuide } from 'js/src/agent/html-design/authoringGuide';

/**
 * A skill rather than prompt text because the animation index alone runs to ~80 entries, which would
 * cost more than the Toolbox's whole preamble and only matters while a graphic is being authored.
 */
export const htmlCompositionSkill: Skill = {
    name: SKILL_NAMES.htmlComposition,
    description:
        'How to author the HTML composition behind a motion graphics scene: the document ' +
        'contract, how to label its selectable parts, the style rules a graphic is judged ' +
        'against, and the index of animation techniques you can load. Load BEFORE writing any ' +
        'composition HTML.',
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `# Authoring an HTML composition

A motion graphics scene's content is a self-contained HTML document you write. It is rendered by
seeking a paused timeline frame-by-frame, so it must be a deterministic, seekable function of time.

${getCompositionAuthoringGuide()}`;
    },
};
